import { render, staticRenderFns } from "./SupportUs.vue?vue&type=template&id=aae6d366"
import script from "./SupportUs.vue?vue&type=script&lang=js"
export * from "./SupportUs.vue?vue&type=script&lang=js"
import style0 from "./SupportUs.vue?vue&type=style&index=0&id=aae6d366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports